import cn from 'classnames';
import React, {useEffect, useRef, useState} from 'react';
import CustomButton from '../../../../../components/mazraeKit/customButton';

import ReactCrop, {
  Crop,
  PixelCrop,
  centerCrop,
  makeAspectCrop,
} from 'react-image-crop';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {RootState} from '../../../../../store/redux';
import {canvasPreview} from '../../../../../utilities/hooks/imageCropper/canvasPreview';
import {useDebounceEffect} from '../../../../../utilities/hooks/imageCropper/useDebounceEffect';
import './style.css';

import {toast} from 'react-toastify';
import usePostWriteImageInStorage from '../../../../../services/hookService/postwriteImageInStorage/usePostWriteImageInStorage';
import {
  addingCropedImage,
  clearImage,
} from '../../../../../store/redux/addPictureAdvertisment';

const AdverAddPicture = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {imageFile} = useSelector(
    (state: RootState) => state.addPictureAdvertisement,
  );
  const [imgSrc, setImgSrc] = useState('');
  const previewCanvasRef = useRef<HTMLCanvasElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();

  const handleAfterSuccess = (data?: number, file?: File) => {
    if (file) {
      dispatch(addingCropedImage({file: file, id: data, flag: false}));
      dispatch(clearImage());
      navigate(-1);
    }
  };

  const {mutate, writeInImageStorageIsLoading} =
    usePostWriteImageInStorage(handleAfterSuccess);

  function onSelectFile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      setCrop(undefined);
      const reader = new FileReader();
      reader.addEventListener('load', () =>
        setImgSrc(reader.result?.toString() || ''),
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  }
  useEffect(() => {
    imageFile && onSelectFile(imageFile);
  }, [imageFile]);

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        canvasPreview(imgRef.current, previewCanvasRef.current, completedCrop);
      }
    },
    100,
    [completedCrop],
  );
  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    const {width, height} = e.currentTarget;
    setCrop(centerAspectCrop(width, height, 1));
  }

  async function onDownloadCropClick() {
    setIsLoading(true);

    if (!previewCanvasRef.current) {
      throw new Error('Crop canvas does not exist');
    }

    previewCanvasRef?.current.toBlob(blob => {
      if (!blob) {
        toast.error('مشکلی در آپلود عکس پیش آمده.');
      } else {
        if (
          imageFile &&
          imageFile?.target.files &&
          imageFile?.target.files.length > 0
        ) {
          if (imageFile?.target.files[0].size >= 10 * 1024 * 1024) {
            toast.error('حجم تصویر نباید بیشتر از 10 مگابایت باشد.');
            setIsLoading(false);
            return;
          } else {
            // Replace file name since some file name are not supported by backend
            const originalFile = imageFile.target.files[0];
            const extension = originalFile.name.split('.').pop() || 'jpg';

            // Change name Simple timestamp
            const safeFileName = `image_${Date.now()}.${extension}`;

            const file = new File([blob], safeFileName, {
              type: blob.type,
            });

            mutate(
              {image: file},
              {
                onSuccess: data => handleAfterSuccess(data.image_id, file),
              },
            );
          }
        }
      }
      setIsLoading(false);
    });
  }

  return (
    <div className="flex-col justify-between w-full h-full d-flex">
      <div className="flex w-full ReactCrop__child-wrapper-image-cropper">
        {!!imgSrc && (
          <ReactCrop
            className="w-full h-full"
            crop={crop}
            onChange={(_, percentCrop) => setCrop(percentCrop)}
            onComplete={c => setCompletedCrop(c)}
          >
            <img
              className="object-contain h-full"
              ref={imgRef}
              alt="Crop me"
              src={imgSrc}
              onLoad={onImageLoad}
            />
          </ReactCrop>
        )}
        {!!completedCrop && (
          <>
            <div className=" d-none">
              <canvas
                ref={previewCanvasRef}
                style={{
                  border: '1px solid black',
                  objectFit: 'contain',
                  width: completedCrop.width,
                  height: completedCrop.height,
                }}
              />
            </div>
          </>
        )}
      </div>
      <div className="d-flex gap-2 px-2  w-full items-center rounded-t-[8px] text-md font-Medium h-[64px] shadow-dropShadow">
        <CustomButton
          disabled={isLoading || writeInImageStorageIsLoading}
          onClick={() => {
            onDownloadCropClick();
          }}
          type="button"
          title=" انتخاب تصویر"
          isLoading={isLoading}
          className={cn(
            'w-[50%] text-white h-[48px] flex rounded-[8px] items-center justify-center border border-farm-shop-500',
            {
              'bg-farm-shop-200': writeInImageStorageIsLoading,
              'bg-farm-shop-500': !writeInImageStorageIsLoading,
            },
          )}
        />
        <CustomButton
          onClick={() => {
            navigate(-1);
            dispatch(clearImage());
          }}
          type="submit"
          title="انصراف"
          isLoading={false}
          className="text-farm-shop-500 w-[50%] h-[48px] flex items-center justify-center rounded-[8px] border border-farm-shop-500"
        />
      </div>
    </div>
  );
};

export default AdverAddPicture;
function centerAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number,
) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 90,
      },
      aspect,
      mediaWidth,
      mediaHeight,
    ),
    mediaWidth,
    mediaHeight,
  );
}
